<script>
export default {
  methods: {
    allowQuantityPartials(bestPrice) {
      return bestPrice?.partPackagingAllowed;
    },
  },
};
</script>
